"use client"

import { HStack, Icon, Text } from "@chakra-ui/react"

import { Post } from "@/types/database"

import { Option } from "./TSearchModal"
import { ArrowUpRightOutlineIcon } from "@/components/icons"

const SearchItem = ({
  handleItemClick,
  highlightedIndex,
  index,
  item,
}: {
  item: Option
  index: number
  highlightedIndex: number
  handleItemClick: (item: Option | Post) => void
}) => (
  <HStack
    _hover={{
      _dark: {
        bgColor: "primary.300/10",
      },
      bgColor: "primary.500/10",
      color: "primary.fg",
    }}
    alignItems="stretch"
    aria-selected={highlightedIndex === index}
    bgColor={highlightedIndex === index ? "primary.500/10" : "transparent"}
    borderColor={highlightedIndex === index ? "border" : "transparent"}
    borderStyle="solid"
    borderWidth="1px"
    color={highlightedIndex === index ? "primary.fg" : "fg.muted"}
    cursor="pointer"
    id={`search-item-${index}`}
    onClick={() => handleItemClick(item)}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()
        handleItemClick(item)
      }
    }}
    px={3}
    py={2}
    role="option"
    tabIndex={highlightedIndex === index ? 0 : -1}
    transition={"color 0.2s ease, background-color 0.2s ease"}
  >
    <Icon
      as={item.icon}
      color="currenColor"
      flexShrink={0}
      size={"md"}
      transition={"color 0.2s ease, background-color 0.2s ease"}
    />
    <Text flex="1">{item.name}</Text>
    <Icon
      as={ArrowUpRightOutlineIcon}
      color="currenColor"
      size={"md"}
      transition={"color 0.2s ease, background-color 0.2s ease"}
    />
  </HStack>
)

export default SearchItem
